import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../utils/Hooks";
import { Link, useLocation, useParams } from "react-router-dom";
import { LoggedInView } from "../common/LoggedInView";
import Breadcrumbs from "../common/Breadcrumbs";
import ElogInput from "../common/form/ElogInput";
import { BreadcrumbLink } from "../../models/BreadcrumbLink";
import {
    getCurrentOfflineReason,
    resetUpdateOfflineReasonStatus,
    updateOfflineReason,
} from "../../store/reducers/OfflineReasonsSlice";
import { RequestStatus } from "../../utils/Enums";
import ElogTextarea from "../common/form/ElogTextarea";
import {useFormik, Form, FormikProvider} from "formik";
import {createSMSSender} from "../../store/reducers/SMSSendersSlice";

interface ModifyOfflineReasonScreenProps {}

export interface ModifyOfflineReasonFormProps {
    name: string;
}

export const ModifyOfflineReasonScreen: React.FC<ModifyOfflineReasonScreenProps> = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();

    const { id } = useParams();

    const offlineReasonsState = useAppSelector(
        (state) => state.offlineReasons
    );

    const requestStatus: RequestStatus =
        offlineReasonsState.updateOfflineReasonStatus;

    const breadcrumbLinks: BreadcrumbLink[] = [
        { text: "Miks väljas põhjused", url: "/offline-reasons" },
        { text: "Miks väljas põhjuse muutmine", url: `/offline-reasons/${id}/modify` },
    ];

    useEffect(() => {
        dispatch(resetUpdateOfflineReasonStatus());
    }, [location]);

    useEffect(() => {
        dispatch(getCurrentOfflineReason({ id }));
    }, [id]);

    // @ts-ignore
    const formik = useFormik({
        initialValues: {
            name:
                offlineReasonsState?.currentOfflineReason?.name ?? "",
        },
        onSubmit: (values: any) => {
            dispatch(updateOfflineReason({ id, data: values }));;
        },
        enableReinitialize: true
    });

    const {values, setFieldValue, handleSubmit} = formik;

    return (
        <LoggedInView fullWidth={false}>
            <Breadcrumbs links={breadcrumbLinks} />
            {requestStatus === RequestStatus.Success && (
                <div className="message msg-ok">
                    <div>
                        <h2>Andmed muudetud</h2>
                    </div>
                </div>
            )}
            {requestStatus === RequestStatus.Failed &&
            offlineReasonsState.errors.length > 0 && (
                <div className="message msg-error">
                    <div>
                        <h2>Viga:</h2>
                        {offlineReasonsState.errors.map((error, index) => (
                            <span key={index}>
                                    {error}
                                <br />
                                </span>
                        ))}
                    </div>
                </div>
            )}
            <FormikProvider value={formik}>
                <Form onSubmit={handleSubmit}>
                    <div className="form">
                        <h2>
                            <span>Offline põhjuse andmed</span>
                        </h2>
                        <table className="form">
                            <tbody>
                            <ElogInput
                                label="Nimi"
                                name="name"
                                mandatory={true}
                            />
                            </tbody>
                        </table>
                    </div>
                    <div className="action clear">
                        <p>
                            <button type="submit">
                                    <span>
                                        <strong>Muuda</strong>
                                    </span>
                            </button>
                            <Link to="/offline-reasons">Tühista</Link>
                        </p>
                    </div>
                </Form>
            </FormikProvider>
        </LoggedInView>
    );
};